import xesCookie from 'src/utils/utils'
import $axios from './axios'
import { MessageBox, Loading } from 'element-ui'
const setRouter = {
    // 进入视图之前
    beforeEach(to, from, next) {
        if (
            window.location.search &&
            to.path.indexOf('preview') !== -1 &&
            to.query.isCourse !== 1
        ) {
            //预览视图不加验证
            let query = window.location.search.substr(1).split('&')
            let params = {}
            query.forEach(el => {
                let i = el.indexOf('=')
                params[el.slice(0, i)] = el.slice(++i)
            })
            window.token = params['token']
            next()
        } else {
            if (!setRouter.isToken(to, from, next)) {
                // 本地是否有token
                MessageBox.alert('未登录，请先进入门户平台登录！', '提示', {
                    confirmButtonText: '确定',
                    callback: () => {
                        const url = xesCookie.getUrlParams('domain')
                        window.location.href = url || 'https://tnt.saasz.vdyoo.com/'
                    }
                })
                return
            }
            setRouter.isCheckoutLogin(to, from, next)
        }
    },
    // 本地是否有token
    isToken(to, from, next) {
        let state = false
        let childrenToken = xesCookie.getCookie('childrenToken')
        let token = xesCookie.getToken()
        if (childrenToken) {
            //第一次登录
            window.token = token
            xesCookie.delCookie('childrenToken', true)
            setRouter.redirect(to, from, next)
            state = true
        } else if (token) {
            //已登录
            window.token = token
            state = true
        }
        return state
    },
    // 门户登陆验证
    isCheckoutLogin(to, from, next) {
        let LoadingObj = setRouter.loading()
        LoadingObj.show()
        $axios
            .get('https://tntapi.saasz.vdyoo.com/login/checkLogin', { customGo: true })
            .then(
                res => {
                    LoadingObj.hide()
                    if (res.data.status === 100) {
                        next()
                    } else {
                        MessageBox.alert(
                            '未登录，请先进入门户平台登录！',
                            '提示',
                            {
                                confirmButtonText: '确定',
                                callback: () => {
                                    const url = xesCookie.getUrlParams('domain')
                                    window.location.href = url || 'https://tnt.saasz.vdyoo.com/'
                                }
                            }
                        )
                    }
                },
                () => {
                    LoadingObj.hide()
                    MessageBox.alert('网络异常，点击确定后重试。', '提示', {
                        confirmButtonText: '确定',
                        callback: () => {
                            window.location.reload()
                        }
                    })
                }
            )
    },
    // 路由重定向
    redirect(to, from, next) {
        if (window.location.search) {
            let _url = window.location.href.replace(/\?(.*)/, '')
            window.history.pushState({}, 0, _url)
            from.meta.first = true
            next('courseware/list')
        } else if (to.path === '/') {
            from.meta.first = true
            next('courseware/list')
        }
        next()
    },
    // loading
    loading() {
        const result = {}
        // 定义loading显示缓冲
        result.waitTimer = null
        // 设置缓冲时间
        result.waitTime = 500
        result.loadingEle = null
        // 显示loading
        result.show = () => {
            // 定义1s之后显示loading，避免闪现
            clearTimeout(result.waitTimer)
            result.waitTimer = null
            result.waitTimer = setTimeout(() => {
                // 创建loading遮罩元素
                result.loadingEle = Loading.service({
                    lock: true,
                    text: 'Loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                result.waitTimer = null
            }, result.waitTime)
        }

        // 隐藏loading
        result.hide = () => {
            if (result.waitTimer) {
                clearTimeout(result.waitTimer)
                result.waitTimer = null
                return
            }
            if (result.loadingEle) {
                result.loadingEle.close()
            }
        }
        return result
    }
}
export default setRouter



// WEBPACK FOOTER //
// ./src/config/setRouter.js